import { useState, useEffect } from "react";
import { axiosCarvenui } from "../../util/integration";

export const useBrands = () => {
  const [brands, setBrands] = useState([]);
  const [brandsCount, setBrandsCount] = useState(0);
  const [collapseBrands, setCollapseBrands] = useState(true);
  const [searchKey, setSearchKey] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch initial brands
  useEffect(() => {
    const getFilterData = async () => {
      try {
        setLoading(true);
        const brands_res = await axiosCarvenui.get(`/brand?page_size=7`);
        const brands_data = brands_res.data.results.map((brand) => ({
          ...brand,
          value: brand.id,
        }));
        setBrands(brands_data);
        setBrandsCount(brands_res.data.count);
      } catch (error) {
        console.error("Error fetching brands:", error);
      } finally {
        setLoading(false); // 👈 stop loading
      }
    };
    getFilterData();
  }, []);

  const getAllBrands = async () => {
    try {
      setLoading(true);
      let q =
        searchKey && searchKey !== ""
          ? `/brand?page_size=${brandsCount}&name__icontains=${searchKey}`
          : `/brand?page_size=${brandsCount}`;

      const brands_res = await axiosCarvenui.get(q);
      const brands_data = brands_res.data.results.map((brand) => ({
        ...brand,
        value: brand.id,
      }));
      setBrands(brands_data);
      setBrandsCount(brands_res.data.count);
    } catch (error) {
      console.error("Error fetching all brands:", error);
    } finally {
      setLoading(false);
    }
  };

  const sortBrands = (allBrands, selectedBrands) => {
    const selectedIds = new Set([...selectedBrands].map((b) => b.id));
    setBrands([
      ...selectedBrands,
      ...allBrands.filter((d) => !selectedIds.has(d.id)),
    ]);
  };

  const searchBrand = async (value) => {
    try {
      setLoading(true);
      let q =
        value && value !== ""
          ? `/brand?page_size=50&name__icontains=${value}`
          : `/brand?page_size=50`;

      const res = await axiosCarvenui.get(q);
      const data = res.data.results.map((brand) => ({
        ...brand,
        value: brand.id,
      }));

      setBrands(data);
      setBrandsCount(data.length);
    } catch (error) {
      console.error("Error searching brands:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    brands,
    setBrands,
    brandsCount,
    setBrandsCount,
    collapseBrands,
    setCollapseBrands,
    searchKey,
    setSearchKey,
    getAllBrands,
    sortBrands,
    searchBrand,
    brandLoading: loading,
  };
};
